/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Bundle Removal Handler - YCL Style
  // Removes all items in a bundle when the remove link is clicked
  function initBundleRemoval() {
    document.addEventListener('click', function(e) {
      const removeLink = e.target.closest('[data-bundle-remove]');
      if (!removeLink) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const bundleId = removeLink.dataset.bundleRemove;
      const bundleKeys = removeLink.dataset.bundleKeys;

      if (!bundleKeys) {
        console.error('No bundle keys found for removal');
        return;
      }

      // Split comma-separated keys and filter empty strings
      const keysToRemove = bundleKeys.split(',').filter(key => key.trim());

      if (keysToRemove.length === 0) {
        console.error('No valid keys found to remove');
        return;
      }

      // Show loading state
      const originalText = removeLink.textContent;
      removeLink.style.pointerEvents = 'none';
      removeLink.style.opacity = '0.5';
      removeLink.textContent = 'Removing...';

      // Build updates object to set quantity to 0 for all bundle items
      const updates = {};
      keysToRemove.forEach(key => {
        updates[key.trim()] = 0;
      });

      console.log('Keys to remove:', keysToRemove);
      console.log('Updates object:', updates);

      // Send cart update request
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Bundle removed successfully:', bundleId);

        // Trigger cart refresh (theme-specific event or page reload)
        if (window.theme && typeof window.theme.cartRefresh === 'function') {
          window.theme.cartRefresh();
        } else {
          // Fallback: reload the page or trigger custom event
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          // If no event handler exists, reload as last resort
          setTimeout(() => {
            if (typeof theme !== 'undefined' && theme.cart) {
              theme.cart.load();
            } else {
              window.location.reload();
            }
          }, 100);
        }
      })
      .catch(error => {
        console.error('Error removing bundle:', error);
        removeLink.style.pointerEvents = '';
        removeLink.style.opacity = '';
        removeLink.textContent = originalText;
        alert('Failed to remove bundle. Please try again.');
      });
    }, true); // Use capture phase to run before theme's handler
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleRemoval);
  } else {
    initBundleRemoval();
  }

  // Size Guide Drawer Handler
  // Opens and closes the size guide drawer with accessibility features
  function initSizeGuideDrawer() {
    const drawer = document.querySelector('[data-size-guide-drawer]');
    if (!drawer) return; // No size guide on this page

    const openTriggers = document.querySelectorAll('[data-size-guide-open]');
    const closeTriggers = drawer.querySelectorAll('[data-size-guide-close]');
    const drawerBody = drawer.querySelector('[data-size-guide-body]');

    // Store previously focused element for accessibility
    let previouslyFocused = null;

    // Open drawer
    function openDrawer(e) {
      e.preventDefault();
      previouslyFocused = document.activeElement;
      drawer.classList.add('is-visible');
      document.documentElement.classList.add('drawer-open');

      // Initialize unit converter after drawer opens
      setTimeout(() => {
        initUnitConverter();
      }, 50);

      // Focus on close button for accessibility
      setTimeout(() => {
        const closeButton = drawer.querySelector('[data-size-guide-close]');
        if (closeButton) closeButton.focus();
      }, 100);

      // Scroll to top of drawer content
      if (drawerBody) drawerBody.scrollTop = 0;
    }

    // Close drawer
    function closeDrawer(e) {
      if (e) e.preventDefault();
      drawer.classList.remove('is-visible');
      document.documentElement.classList.remove('drawer-open');

      // Return focus to trigger for accessibility
      if (previouslyFocused) {
        previouslyFocused.focus();
        previouslyFocused = null;
      }
    }

    // Attach event listeners to open triggers
    openTriggers.forEach(trigger => {
      trigger.addEventListener('click', openDrawer);
    });

    // Attach event listeners to close triggers
    closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', closeDrawer);
    });

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-visible')) {
        closeDrawer();
      }
    });
  }

  // Match variant header row width to variant buttons
  function matchVariantHeaderWidth() {
    const variantHeaderRows = document.querySelectorAll('.variant-header-row');

    variantHeaderRows.forEach(headerRow => {
      const fieldset = headerRow.closest('.radio__fieldset');
      if (!fieldset) return;

      const variantButtons = fieldset.querySelector('.radio__buttons');
      if (!variantButtons) return;

      // Get the admin-set max-width percentage
      const maxWidthStyle = headerRow.style.maxWidth;
      const maxWidthPercent = maxWidthStyle ? parseFloat(maxWidthStyle) : 100;

      // Calculate the actual max width based on the parent
      const parentWidth = fieldset.offsetWidth;
      const maxWidthPx = (parentWidth * maxWidthPercent) / 100;

      // Get variant buttons width
      const buttonsWidth = variantButtons.offsetWidth;

      // Use the smaller of: buttons width or admin max-width setting
      const targetWidth = Math.min(buttonsWidth, maxWidthPx);

      // Apply the width (respecting the 300px minimum from CSS)
      headerRow.style.width = `${targetWidth}px`;
    });
  }

  // Initialize size guide drawer on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSizeGuideDrawer();
      matchVariantHeaderWidth();
    });
  } else {
    initSizeGuideDrawer();
    matchVariantHeaderWidth();
  }

  // Re-match width on window resize
  window.addEventListener('resize', matchVariantHeaderWidth);

  // Size Guide Unit Converter (CM to IN)
  function initUnitConverter() {
    const converter = document.querySelector('.size-guide__unit-converter');
    if (!converter) return;

    const toggleButtons = converter.querySelectorAll('.unit-toggle');
    const table = document.querySelector('[data-size-table]');
    if (!table) return;

    const measurementCells = table.querySelectorAll('td[data-measurement]');

    toggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        const unit = button.dataset.unit;

        // Update active state
        toggleButtons.forEach(btn => btn.classList.remove('unit-toggle--active'));
        button.classList.add('unit-toggle--active');

        // Convert measurements
        measurementCells.forEach(cell => {
          const originalValue = cell.dataset.measurement;
          if (!originalValue || originalValue === '-') return;

          // Parse the value (handle ranges like "89-94" and single values like "89")
          const values = originalValue.split('-').map(v => parseFloat(v.trim()));

          if (unit === 'in') {
            // Convert CM to IN (divide by 2.54)
            const convertedValues = values.map(v => (v / 2.54).toFixed(1));
            cell.textContent = convertedValues.join('-');
          } else {
            // Show original CM values
            cell.textContent = originalValue;
          }
        });
      });
    });
  }

  // Initialize size guide drawer on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSizeGuideDrawer();
      matchVariantHeaderWidth();
    });
  } else {
    initSizeGuideDrawer();
    matchVariantHeaderWidth();
  }




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
